/**
 * Advisor schedule CTA eligibility for Spend Check results.
 * Product: $100K+ household income OR $100K+ investable assets (not AND).
 */
export function qualifiesForSpendCheckAdvisor(annualIncome: number, investableAssetsRange: string): boolean {
  if (annualIncome >= 100_000) return true
  if (!investableAssetsRange || investableAssetsRange === 'UNDER_100K') return false
  return true
}
